import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but reserves stock for other lines of the same variant.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Allow this line's quantity plus unallocated stock. For a quick-order row,
   * lineQuantity is the aggregate variant quantity, so its limit is the full cap.
   * @returns {number | null}
   */
  getEffectiveMax() {
    const { max, cartQuantity } = this.getCurrentValues();
    if (max === null) return null;
    const lineQuantity = Number(this.refs.quantityInput.dataset.lineQuantity) || 0;
    return Math.max(0, max - Math.max(0, cartQuantity - lineQuantity));
  }

}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
